//import '@babel/polyfill'
//import 'mutationobserver-shim'
import Vue from 'vue';
import App from './App.vue'
import VueProgressBar from 'vue-progressbar';
import ToggleButton from "vue-js-toggle-button";
import router from './router';
import store from './store';
import './plugins/axios';
import './plugins/bootstrap-vue';
import UUID from 'vue-uuid';

Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px',
  thickness: '10px',
  location : 'top'
});

Vue.use(UUID);
Vue.config.productionTip = false;
Vue.use(ToggleButton);

Vue.mixin({
  methods: {
    generateSecret() {
      const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^*-+_=";
      var values = new Uint8Array(40);
      var secret = "";
      window.crypto.getRandomValues(values);

      values.forEach(function(value) {
        secret += chars[Math.floor(value/255*(chars.length-1))];
      });

      return secret;
    }
  }
});
export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
